import { ObjectHelpers } from "../../helpers/object-helpers";
import { ChartStyleColorModel } from "../chart-style/chart-style-color.model";

export class DrawTradePriceAnnotationModel {
    public name = '';
    public label = '';
    public x = 0;
    public y = 0;
    public color = new ChartStyleColorModel();
    public element: HTMLElement | null = null;

    constructor(data?: any) {
        if (data) {
            this.name = data.name;
            this.label = data.label;
            this.x = data.x;
            this.y = data.y;
            this.color = new ChartStyleColorModel(data.color);
        }
    }
}